import React, { useEffect, useRef, useState } from 'react';

import { appConfig, lang, logger } from './services';
import { LanguageContext } from './contexts/LanguageContext';

import LoadingSpinner from './components/LoadingSpinner';
import MainPage from '@active-version/MainPage';
import TermsModal from './components/TermsModal'

function App() {
    const location = window.location;
    const search = location.search;
    const hash = location.hash;
    const params = new URLSearchParams(search);
    const paramsLanguage = params.get('lang') || new URLSearchParams(hash).get('lang') || localStorage.getItem("lang");

    const [isConfigReady, setConfigReady] = useState(false);
    const [isTermsModal, setTermsModal] = useState(false)
    //eslint-disable-next-line
    const [isLangReady, setLangReady] = useState(false);
    const [language, setLanguage] = useState("");
    const prevLanguage = useRef(language);

    useEffect(() => {
        document.body.classList.add(appConfig.site.defaultTheme);
        document.title = "Loading...";

        appConfig.loadConfig().then(() => {
            setConfigReady(true);
            document.title = appConfig.defines.SITE_NAME;
            setLanguage(paramsLanguage || appConfig.defines.DEFAULT_LANGUAGE)
        });
        //eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (!language) return;

        try {
            window.document.documentElement.setAttribute("lang", language);
        } catch (e) { }

        setLangReady(false);

        lang.init(language)
            .catch((e) => {
                logger.error('Cannot loading lang: ' + language);

                if (language !== prevLanguage.current) { // prevent endless loop
                    setLanguage(prevLanguage.current); // don't change language
                }
            })
            .then(() => {
                localStorage.setItem("lang", language);
                prevLanguage.current = language;

                setLangReady(true);
            });
    }, [language])

    return isConfigReady ? (
        <div className="App">
            <LanguageContext value={{ language, setLanguage }}>
                <MainPage setTermsModal={() => setTermsModal(true)} />
            </LanguageContext>
            {isTermsModal &&
                <TermsModal
                    onCloseTerms={() => setTermsModal(false)}
                    proxyName={appConfig.defines.SITE_NAME}
                />
            }

        </div>
    ) : <LoadingSpinner />;
}

export default App;
